export const timeMinutes = (value) => {
  if (!/^\d{2}:\d{2}$/.test(value || "")) return null;
  const [h, m] = value.split(":").map(Number);
  return h < 24 && m < 60 ? h * 60 + m : null;
};
export const durationMinutes = (value) => {
  const n = Number.parseInt(String(value || "60"), 10);
  return Number.isFinite(n) && n > 0 ? n : 60;
};
export function scheduleConflicts({
  date,
  time,
  duration,
  doctorId = "",
  excludeId,
  defaultDuration = 60,
  appointments = [],
  blocks = [],
}) {
  const start = timeMinutes(time),
    end = start + durationMinutes(duration);
  if (!date || start === null || end > 1440) return [];
  const overlaps = (from, to) =>
    from !== null && to !== null && start < to && end > from;
  const visits = appointments.filter((item) => {
    if (
      item.id === excludeId ||
      item.fecha !== date ||
      ["cancelada", "cancelado", "canceled", "cancelled"].includes(
        String(item.estado || "").toLowerCase(),
      )
    )
      return false;
    if (doctorId && item.doctorId && item.doctorId !== doctorId) return false;
    const from = timeMinutes(item.hora);
    return overlaps(
      from,
      from === null
        ? null
        : from + durationMinutes(item.duracion || defaultDuration),
    );
  });
  return [
    ...visits,
    ...blocks
      .filter(
        (item) =>
          item.fecha === date &&
          (item.alcance === "todos" ||
            (item.alcance === "doctor" &&
              doctorId &&
              item.doctorId === doctorId)) &&
          overlaps(timeMinutes(item.horaInicio), timeMinutes(item.horaFin)),
      )
      .map((item) => ({ ...item, tipo: "bloqueoAgenda" })),
  ];
}
